<p class="doc-link">{{ message() }}</p>
